import { isValidCnpjInput } from '@solfacil/frontend-utils/cnpj';
import { z } from 'zod';

const partnersFiltersSchema = z.object({
  document: z.string()
    .optional()
    .refine((val) => !val?.trim() || isValidCnpjInput(val), { message: 'CNPJ inválido' }),
  partial_name: z.string().optional(),
});

export default partnersFiltersSchema;
